<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading" v-if="group.id">
        {{ $t('group.edit') }}
      </div>
      <div class="content-heading" v-else>
        {{ $t('group.add') }}
      </div>
      <div class="row">
        <div class="col-xl-4">
          <div class="card card-default">
            <div class="card-body">
              <form @submit.prevent="save" class="form-modal form-group">

                <div class="form-group">
                  <label for="name">{{ $t('group.name') }} *</label>
                  <input
                    :class="{'parsley-error': errors.name}"
                    autocomplete="off"
                    class="form-control"
                    id="name"
                    :placeholder="$t('group.insert-name')"
                    type="text"
                    v-model="group.name">
                  <ul class="parsley-errors-list filled" v-if="errors.name">
                    <li class="parsley-required">{{ errors.name[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label> {{ $t('tender.additional-info') }}</label>
                  <textarea
                    v-model="group.default_additional_info"
                    class="form-control"
                    :class="{'parsley-error': errors.default_additional_info}"
                    rows="4"
                    type="text">
                  </textarea>
                  <ul class="parsley-errors-list filled" v-if="errors.default_additional_info">
                    <li class="parsley-required">{{ errors.default_additional_info[0] }}</li>
                  </ul>
                </div>

                <div class="row pb-3">
                  <div class="col-md-6">
                    <div class="checkbox c-checkbox">
                      <label for="is_active">
                        <input
                          v-model="group.is_active"
                          :class="{'parsley-error': errors.is_active}"
                          class="form-control"
                          type="checkbox"
                          id="is_active">
                        <span class="fa fa-check"></span> {{ $t('group.active') }}
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6" v-if="!this.group.id">
                    <more/>
                  </div>

                </div>
                <buttons url="groups"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Buttons from '@/components/Buttons.vue'
import message from '@/message'
import More from '@/components/More.vue'
import {parseApiError} from '@/utils'

const getData = (id, next) => {
  if (id) {
    Promise.all([api.get(`/groups/${id}/`)])
      .then(([group]) => {
        next({
          group: group.data
        })
      })
  } else {
    next({
      group: {
        name: '',
        is_active: true,
        default_additional_info: ''
      }
    })
  }
}

export default {
  components: {
    buttons: Buttons,
    more: More
  },
  data() {
    return {
      group: {},
      more: null,
      errors: {}
    }
  },
  computed: {
    is_supplier() {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted() {
    this.$parent.menu = 'setup'
    this.$parent.submenu = 'groups'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    save() {
      this.errors = {}

      if (this.group.id) {
        api.patch(`/groups/${this.group.id}/`, this.group)
          .then(() => {
            message.success(this.$i18n.t('group.changed'))
            this.$router.push({name: 'groups'})
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      } else {
        api.post('/groups/', this.group)
          .then(() => {
            message.success(this.$i18n.t('group.added'))
            if (this.more) {
              this.group.name = ''
              this.group.is_active = true
              this.group.default_additional_info = ''
              this.$router.push({name: 'group_add'})
            } else {
              this.$router.push({name: 'groups'})
            }
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    getData(to.params.id, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate(to, from, next) {
    getData(to.params.id, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Group.vue